import { api } from '../axios'
import type { ApiResponse } from '../../../types'

export const nonActiveTypesApi = {
  getAll: () =>
    api.get<ApiResponse<any[]>>('/non-active-types'),

  getActive: () =>
    api.get<ApiResponse<any[]>>('/non-active-types/active'),

  getById: (id: number) =>
    api.get<ApiResponse<any>>(`/non-active-types/${id}`),

  create: (data: { name: string; code?: string; is_active?: boolean }) =>
    api.post<ApiResponse<any>>('/non-active-types', data),

  update: (id: number, data: { name?: string; code?: string; is_active?: boolean }) =>
    api.put<ApiResponse<any>>(`/non-active-types/${id}`, data),

  delete: (id: number) =>
    api.delete<ApiResponse>(`/non-active-types/${id}`),

  hardDelete: (id: number) =>
    api.delete<ApiResponse>(`/non-active-types/${id}/permanent`),
}

